const BASE_URL = "https://verify6-5407-sgpe0w.twil.io";

export const normalizePhoneNumber = (phoneNumber) => {
  const clean = (phoneNumber || "").replace(/\D/g, "");
  if (!clean) return "";
  if (clean.startsWith("90")) return `+${clean}`;
  return `+90${clean}`;
};

const parseJsonSafe = async (response) => {
  try {
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
};

export const sendSmsVerification = async (phoneNumber) => {
  try {
    const formattedPhone = normalizePhoneNumber(phoneNumber);
    const response = await fetch(`${BASE_URL}/start-verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to: formattedPhone, channel: "sms" }),
    });
    const json = await parseJsonSafe(response);
    if (!response.ok) {
      return { success: false, phoneNumber: formattedPhone, message: json?.message || "SMS gönderilemedi." };
    }
    return { success: !!json?.success, phoneNumber: formattedPhone, message: json?.message || "" };
  } catch (error) {
    return { success: false, phoneNumber: normalizePhoneNumber(phoneNumber), message: error?.message || "SMS gönderilemedi." };
  }
};

export const checkVerification = async (phoneNumber, code) => {
  try {
    const formattedPhone = normalizePhoneNumber(phoneNumber);
    const response = await fetch(`${BASE_URL}/check-verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to: formattedPhone, code }),
    });
    const json = await parseJsonSafe(response);
    if (!response.ok) {
      return { success: false, phoneNumber: formattedPhone, message: json?.message || "Kod doğrulanamadı." };
    }
    return { success: !!json?.success, phoneNumber: formattedPhone, message: json?.message || "" };
  } catch (error) {
    return { success: false, phoneNumber: normalizePhoneNumber(phoneNumber), message: error?.message || "Kod doğrulanamadı." };
  }
};
